import styled from "styled-components";

const ImageContainer = styled.div``;
const ImageCard = styled.div`
  background: white;
  border-radius: 20px;
  flex: 0 0 400px;
  height: fit-content;

  @media (max-width: 992px) {
    flex: none;
    width: 100%;
  }
`;
const ImageView = styled.div`
  position: relative;
  width: ${(props) => (props.sm ? "400px" : "470px")};
  height: ${(props) => (props.sm ? "400px" : "580px")};
  object-fit: cover;
  border-radius: 20px;
  align-items: center;
  justify-content: center;

  img {
    border-radius: inherit;
    object-fit: cover;
    width: ${(props) => (props.sm ? "400px" : "470px")};
    height: ${(props) => (props.sm ? "400px" : "580px")};
    display: block; /* Ensure image takes full space when loaded */
    border: 1rem solid white;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
  @media screen and (max-width: 992px) {
    width: 100%;
    height: 400px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  /* @media screen and (max-width: 600px) {
    border: 1rem solid white;
  } */
`;

const HeaderText = styled.h4`
  margin-bottom: 20px;
  margin-top: 20px;
  color: red;
  text-align: center;
`;

function ImageSection({ children, imagePath, headerText, sm = false }) {
  return (
    <ImageContainer>
      {headerText && <HeaderText>{headerText}</HeaderText>}
      <ImageView sm={sm}>
        {imagePath ? (
          <img src={imagePath} alt="Coach profile" />
        ) : (
          <div
            style={{
              width: sm ? 400 : "100%",
              height: sm ? 400 : "580px",
              background: "white",
            }}
          />
        )}
        {children}
      </ImageView>
    </ImageContainer>
  );
}

export default ImageSection;
